import React from 'react'
import GraphQLProvider from 'components/GraphQLProvider'
import Channel from './Channel'

export default React.memo(function PublicShareChannel({ token }) {
  return (
    <GraphQLProvider>
      <Channel token={token} />
    </GraphQLProvider>
  )
})
